module.exports = __webpack_public_path__ + "static/media/imageDownload.d24f2a19.png";